<div class="ac-option">
    <ng-content></ng-content>
</div>
